import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { NavigationService} from "../services/navigation.service";
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {ConfirmationDialogComponent} from "../../modules/shared/confirmation-dialog/confirmation-dialog.component";

export const canDeactivateGuard: CanDeactivateFn<any> = (): Observable<boolean> | boolean => {
    const navigationService = inject(NavigationService);
    const dialog = inject(MatDialog);
    if (navigationService.getUnsavedChanges()) {
        const dialogRef = dialog.open(ConfirmationDialogComponent, {
            width: '350px',
            data: {
                message: 'Sie haben Ihre Eingaben nicht gespeichert. Wollen Sie die Seite ohne Speichern verlassen?',
            }
        });
        return dialogRef.afterClosed();
    }
    return true;
};